export default __webpack_public_path__ + "static/media/shilpa-patil.7973da45.png";